import adminSettingsRoutes from "@/router/routes/admin-settings";
import learningRoutes from "@/router/routes/learning";
import orgChartRoutes from "@/router/routes/org-chart";
import skillsRouters from "@/router/routes/skills";
import usersTeamsRoutes from "@/router/routes/users-teams";
import feedbackRoutes from "@/router/routes/feedback";
import meetingsRoutes from "@/router/routes/meetings";
import surveysRoutes from "@/router/routes/surveys";
import goalsRoutes from "@/router/routes/goals";
import reviewsRoutes from "@/router/routes/reviews";
import errorRoutes from "@/router/routes/error";
import authRoutes from "@/router/routes/auth";
import profileRoutes from "@/router/routes/profile";

const routes = [
    ...adminSettingsRoutes,
    ...learningRoutes,
    ...orgChartRoutes,
    ...skillsRouters,
    ...usersTeamsRoutes,
    ...feedbackRoutes,
    ...meetingsRoutes,
    ...surveysRoutes,
    ...goalsRoutes,
    ...reviewsRoutes,
    ...errorRoutes,
    ...authRoutes,
    ...profileRoutes,
    {
        path: "/",
        redirect: "/login",
    },
    {
        path: "*",
        redirect: "/login",
    },
];

export default routes;
